import { Box, Typography, Button, Paper, Chip } from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

const ComingSoon = ({ title = 'Feature Coming Soon', description }) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
      <Paper
        elevation={0}
        sx={{
          textAlign: 'center',
          p: 5,
          maxWidth: 480,
          borderRadius: 3,
          bgcolor: 'background.paper',
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        <ConstructionIcon sx={{ fontSize: 64, color: 'warning.main', mb: 2 }} />
        <Chip label="Beta" size="small" color="warning" variant="outlined" sx={{ mb: 2 }} />
        <Typography variant="h5" fontWeight={600} gutterBottom>
          {title}
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          {description || 'This feature is currently under development and will be available in an upcoming release.'}
        </Typography>
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(-1)}
          sx={{ textTransform: 'none' }}
        >
          Go Back
        </Button>
      </Paper>
    </Box>
  );
};

export default ComingSoon;
